import { Component, Inject, signal } from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { firstValueFrom } from 'rxjs';
import { ProgramBrandingService } from '../../program-branding.service';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { PageLoaderComponent } from '../../../../../../../layouts/components/page-loader/page-loader.component';
import { SwalDialogService } from 'src/app/core/shared/services/swal-dialog.service';

@Component({
  selector: 'vex-brand-edit',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatDividerModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,
    MatRadioModule,
    PageLoaderComponent
  ],
  templateUrl: './brand-edit.component.html',
  styleUrls: ['./brand-edit.component.scss']
})
export class BrandEditComponent {
  form: FormGroup;
  brandId: number;
  brandDetail: any = {};
  isSubmitDisabled = signal<boolean>(false);

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: { brandDetails: any },
    private dialogRef: MatDialogRef<BrandEditComponent>,
    private fb: FormBuilder,

    private ProgramBrandingService: ProgramBrandingService,
    private swalDialogService: SwalDialogService
  ) {
    this.brandId = parseInt(data.brandDetails.brandId);
    this.form = this.fb.group({
      brandName: ['', Validators.required],
      companyName: ['', Validators.required],
      isShowWebsite: ['', Validators.required],
      status: ['none']
    });

    this.brandDetail = data.brandDetails || {};
    if (Object.keys(this.brandDetail).length != 0) {
      this.form.patchValue({
        brandName: this.brandDetail.brandName,
        companyName: this.brandDetail.LinkCompanyName,
        status: this.brandDetail.isTerminateRequest
          ? 'isTerminate'
          : this.brandDetail.isReactivate
          ? 'isReactivate'
          : 'none',
        isShowWebsite: this.brandDetail.uploadToWebsite
      });
    }
  }

  async onSubmit() {
    try {
      if (this.form.invalid) {
        this.form.markAllAsTouched();
        return;
      }
      this.isSubmitDisabled.set(true);
      let brandRequestActionPayload: any = {};
      let form = this.form.value;
      brandRequestActionPayload = {
        brandName: form.brandName,
        LinkCompanyName: form.companyName,
        uploadToWebsite:
          form.showOnWebsite === 'Yes'
            ? this.brandDetail.brandNameRegistrationId
              ? true
              : false
            : false,
        BrandApprove:
          form.BrandStatus == 'Terminate'
            ? 'Terminated'
            : this.brandDetail.brandNameRegistrationId
            ? 'Yes'
            : 'Pending',
        BrandStatus:
          form.BrandStatus == 'Terminate'
            ? 'Terminated'
            : this.brandDetail.brandNameRegistrationId
            ? 'Active'
            : 'Pending'
      };

      await firstValueFrom(
        this.ProgramBrandingService.updateBrand(
          this.brandId,
          brandRequestActionPayload
        )
      );
      this.isSubmitDisabled.set(false);

      await this.swalDialogService.showMessage({
        title: 'The brand updated successfully'
      });
      this.dialogRef.close({ submit: true });
    } catch (err) {
      this.isSubmitDisabled.set(false);

      console.log('err :>> ', err);
    }
  }

  showRadioButtonValues(val: string[]) {
    return val.includes(this.brandDetail.BrandStatus);
  }
}
